import { useEffect, useRef } from "react";

const TrustindexWidget = () => {
  const ref = useRef(null);

  useEffect(() => {
    const slot = document.getElementById("ti-widget-slot");
    if (!slot || !ref.current) return;
    ref.current.appendChild(slot);
    slot.style.display = "block";
    return () => {
      slot.style.display = "none";
      document.body.appendChild(slot);
    };
  }, []);

  return <div ref={ref} data-testid="trustindex-widget" className="min-h-[200px]" />;
};

export default TrustindexWidget;
